/**
 * Comprehensive DFW Geo Data for SEO Landing Pages
 * Includes all major cities and counties in the Dallas-Fort Worth metroplex
 */

export const dfwCounties = {
  dallas: {
    name: "Dallas",
    slug: "dallas-county",
    seat: "Dallas",
    population: "2.6 million",
    description: "Dallas County is the second-most populous county in Texas and the heart of the DFW metroplex. Home to the City of Dallas, it offers diverse communities from urban lofts to suburban estates.",
    cities: ["Dallas", "Irving", "Garland", "Grand Prairie", "Mesquite", "Carrollton", "Richardson", "Rowlett", "DeSoto", "Cedar Hill", "Lancaster", "Duncanville", "Farmers Branch", "Balch Springs", "Seagoville", "Sachse", "Sunnyvale", "Cockrell Hill", "Highland Park", "University Park"],
    keywords: "Dallas County homes for sale by owner, FSBO Dallas County TX, sell house Dallas County, Dallas County real estate by owner, for sale by owner Dallas County Texas"
  },
  tarrant: {
    name: "Tarrant",
    slug: "tarrant-county",
    seat: "Fort Worth",
    population: "2.1 million",
    description: "Tarrant County is the third-most populous county in Texas, anchored by Fort Worth. Known for its Western heritage and growing tech sector, it offers excellent value in real estate.",
    cities: ["Fort Worth", "Arlington", "North Richland Hills", "Euless", "Bedford", "Grapevine", "Hurst", "Keller", "Southlake", "Colleyville", "Mansfield", "Haltom City", "Watauga", "Benbrook", "Richland Hills", "Forest Hill", "White Settlement", "Saginaw", "Lake Worth", "Crowley"],
    keywords: "Tarrant County homes for sale by owner, FSBO Tarrant County TX, sell house Tarrant County, Tarrant County real estate by owner, for sale by owner Tarrant County Texas"
  },
  collin: {
    name: "Collin",
    slug: "collin-county",
    seat: "McKinney",
    population: "1.1 million",
    description: "Collin County is one of the fastest-growing counties in America, known for excellent schools, corporate headquarters, and master-planned communities. A premier destination for families.",
    cities: ["Plano", "McKinney", "Frisco", "Allen", "Wylie", "Richardson", "Murphy", "Sachse", "Lucas", "Prosper", "Celina", "Anna", "Princeton", "Melissa", "Fairview", "Parker", "Lavon", "Nevada", "Farmersville", "Blue Ridge"],
    keywords: "Collin County homes for sale by owner, FSBO Collin County TX, sell house Collin County, Collin County real estate by owner, for sale by owner Collin County Texas"
  },
  denton: {
    name: "Denton",
    slug: "denton-county",
    seat: "Denton",
    population: "950,000",
    description: "Denton County combines college-town culture with rapid suburban growth. Home to two major universities and master-planned communities like Flower Mound and Highland Village.",
    cities: ["Denton", "Lewisville", "Flower Mound", "Carrollton", "Little Elm", "The Colony", "Corinth", "Highland Village", "Lake Dallas", "Sanger", "Aubrey", "Pilot Point", "Argyle", "Roanoke", "Trophy Club", "Copper Canyon", "Double Oak", "Bartonville", "Northlake", "Justin"],
    keywords: "Denton County homes for sale by owner, FSBO Denton County TX, sell house Denton County, Denton County real estate by owner, for sale by owner Denton County Texas"
  },
  rockwall: {
    name: "Rockwall",
    slug: "rockwall-county",
    seat: "Rockwall",
    population: "110,000",
    description: "Rockwall County is the smallest county in Texas by area but one of the wealthiest. Located on Lake Ray Hubbard, it offers lakefront living and excellent schools.",
    cities: ["Rockwall", "Rowlett", "Heath", "Royse City", "Fate", "McLendon-Chisholm"],
    keywords: "Rockwall County homes for sale by owner, FSBO Rockwall County TX, sell house Rockwall County, Rockwall County real estate by owner, for sale by owner Rockwall County Texas"
  },
  kaufman: {
    name: "Kaufman",
    slug: "kaufman-county",
    seat: "Kaufman",
    population: "150,000",
    description: "Kaufman County offers affordable housing with easy access to Dallas. Growing communities like Forney and Terrell provide value for first-time homebuyers and families.",
    cities: ["Kaufman", "Terrell", "Forney", "Crandall", "Kemp", "Mabank", "Combine", "Oak Grove", "Scurry", "Elmo"],
    keywords: "Kaufman County homes for sale by owner, FSBO Kaufman County TX, sell house Kaufman County, Kaufman County real estate by owner, for sale by owner Kaufman County Texas"
  },
  ellis: {
    name: "Ellis",
    slug: "ellis-county",
    seat: "Waxahachie",
    population: "195,000",
    description: "Ellis County features historic downtowns and growing suburbs south of Dallas. Waxahachie's Victorian architecture and Midlothian's growth make it attractive for families.",
    cities: ["Waxahachie", "Midlothian", "Ennis", "Red Oak", "Glenn Heights", "Italy", "Maypearl", "Milford", "Ferris", "Palmer"],
    keywords: "Ellis County homes for sale by owner, FSBO Ellis County TX, sell house Ellis County, Ellis County real estate by owner, for sale by owner Ellis County Texas"
  },
  johnson: {
    name: "Johnson",
    slug: "johnson-county",
    seat: "Cleburne",
    population: "185,000",
    description: "Johnson County offers small-town Texas living with access to Fort Worth. Known for rodeos, ranches, and affordable acreage properties.",
    cities: ["Cleburne", "Burleson", "Mansfield", "Joshua", "Alvarado", "Keene", "Grandview", "Godley", "Venus", "Rio Vista"],
    keywords: "Johnson County homes for sale by owner, FSBO Johnson County TX, sell house Johnson County, Johnson County real estate by owner, for sale by owner Johnson County Texas"
  },
  parker: {
    name: "Parker",
    slug: "parker-county",
    seat: "Weatherford",
    population: "155,000",
    description: "Parker County is known as the Peach Capital of Texas. Located west of Fort Worth, it offers rural living, horse properties, and growing suburban communities.",
    cities: ["Weatherford", "Willow Park", "Hudson Oaks", "Aledo", "Springtown", "Azle", "Annetta", "Cool", "Millsap", "Peaster"],
    keywords: "Parker County homes for sale by owner, FSBO Parker County TX, sell house Parker County, Parker County real estate by owner, for sale by owner Parker County Texas"
  },
  wise: {
    name: "Wise",
    slug: "wise-county",
    seat: "Decatur",
    population: "75,000",
    description: "Wise County offers affordable rural living northwest of Fort Worth. Known for ranches, natural gas production, and small-town communities.",
    cities: ["Decatur", "Rhome", "Newark", "Bridgeport", "Boyd", "Aurora", "Paradise", "Alvord", "Chico", "New Fairview"],
    keywords: "Wise County homes for sale by owner, FSBO Wise County TX, sell house Wise County, Wise County real estate by owner, for sale by owner Wise County Texas"
  },
  hood: {
    name: "Hood",
    slug: "hood-county",
    seat: "Granbury",
    population: "65,000",
    description: "Hood County is centered around Lake Granbury, offering waterfront properties and a charming historic downtown. Popular for retirees and weekend homes.",
    cities: ["Granbury", "Tolar", "Lipan", "Cresson", "Pecan Plantation"],
    keywords: "Hood County homes for sale by owner, FSBO Hood County TX, sell house Hood County, Hood County real estate by owner, for sale by owner Hood County Texas"
  },
  hunt: {
    name: "Hunt",
    slug: "hunt-county",
    seat: "Greenville",
    population: "105,000",
    description: "Hunt County provides affordable living east of Dallas with Lake Tawakoni recreation. Growing communities offer value for commuters to Dallas.",
    cities: ["Greenville", "Commerce", "Quinlan", "Caddo Mills", "Wolfe City", "Campbell", "Celeste", "Lone Oak", "West Tawakoni"],
    keywords: "Hunt County homes for sale by owner, FSBO Hunt County TX, sell house Hunt County, Hunt County real estate by owner, for sale by owner Hunt County Texas"
  },
  somervell: {
    name: "Somervell",
    slug: "somervell-county",
    seat: "Glen Rose",
    population: "9,500",
    description: "Somervell County is home to Dinosaur Valley State Park and the Fossil Rim Wildlife Center. A quiet retreat with unique natural attractions.",
    cities: ["Glen Rose", "Rainbow"],
    keywords: "Somervell County homes for sale by owner, FSBO Somervell County TX, sell house Somervell County, Somervell County real estate by owner"
  }
};

export const dfwCities = {
  // DALLAS COUNTY
  dallas: {
    name: "Dallas",
    slug: "dallas",
    county: "Dallas",
    population: "1.3 million",
    medianPrice: "$425,000",
    description: "Dallas is the vibrant heart of North Texas and the cultural and economic center of DFW. From downtown high-rises to historic neighborhoods like Oak Cliff and Lake Highlands, Dallas offers diverse housing options for every lifestyle. Home to major corporations, world-class arts, and professional sports teams.",
    neighborhoods: ["Uptown", "Highland Park", "Lake Highlands", "Oak Cliff", "Preston Hollow", "Deep Ellum", "Bishop Arts", "Lakewood", "M Streets", "Lower Greenville", "Knox-Henderson", "Kessler Park", "White Rock", "Casa Linda", "Bluffview"],
    zipCodes: ["75201", "75202", "75204", "75205", "75206", "75209", "75214", "75218", "75219", "75220", "75225", "75228", "75230", "75231", "75240"],
    nearbyAttractions: ["Dallas Arboretum", "Perot Museum", "Dallas Zoo", "Klyde Warren Park", "Deep Ellum Entertainment District"],
    schoolDistricts: ["Dallas ISD", "Highland Park ISD", "Richardson ISD"],
    commute: "Central location with DART rail access throughout DFW",
    keywords: "Dallas homes for sale by owner, FSBO Dallas TX, sell my house Dallas, Dallas real estate by owner, for sale by owner Dallas Texas, Dallas FSBO listings, sell home Dallas no agent, Dallas TX homes FSBO"
  },
  irving: {
    name: "Irving",
    slug: "irving",
    county: "Dallas",
    population: "256,000",
    medianPrice: "$375,000",
    description: "Irving is strategically located between Dallas and Fort Worth with excellent access to DFW Airport. The Las Colinas urban center features corporate headquarters, entertainment venues, and upscale housing. A diverse, growing city with strong employment opportunities.",
    neighborhoods: ["Las Colinas", "Valley Ranch", "North Irving", "South Irving", "MacArthur Park"],
    zipCodes: ["75038", "75039", "75060", "75061", "75062", "75063"],
    nearbyAttractions: ["Toyota Music Factory", "Mandalay Canal Walk", "Irving Arts Center", "DFW Airport"],
    schoolDistricts: ["Irving ISD", "Carrollton-Farmers Branch ISD"],
    commute: "15 minutes to downtown Dallas, adjacent to DFW Airport",
    keywords: "Irving homes for sale by owner, FSBO Irving TX, sell house Irving, Irving real estate by owner, Las Colinas homes FSBO, for sale by owner Irving Texas"
  },
  garland: {
    name: "Garland",
    slug: "garland",
    county: "Dallas",
    population: "245,000",
    medianPrice: "$325,000",
    description: "Garland offers affordable housing with excellent Lake Ray Hubbard access. A diverse community with strong manufacturing heritage, Garland provides value for families and first-time buyers. The historic downtown square hosts community events year-round.",
    neighborhoods: ["Lake Highlands", "Firewheel", "Duck Creek", "Downtown Garland", "Eastern Hills"],
    zipCodes: ["75040", "75041", "75042", "75043", "75044", "75048"],
    nearbyAttractions: ["Lake Ray Hubbard", "Firewheel Town Center", "Hawaiian Falls", "Duck Creek Trail"],
    schoolDistricts: ["Garland ISD", "Richardson ISD"],
    commute: "20 minutes to downtown Dallas via I-30 or DART",
    keywords: "Garland homes for sale by owner, FSBO Garland TX, sell house Garland, Garland real estate by owner, for sale by owner Garland Texas"
  },
  richardson: {
    name: "Richardson",
    slug: "richardson",
    county: "Dallas/Collin",
    population: "120,000",
    medianPrice: "$425,000",
    description: "Richardson is the 'Telecom Corridor' of Dallas, home to major tech companies and UTD. Known for excellent schools, diverse dining, and well-maintained neighborhoods. A mature suburb with strong property values and community amenities.",
    neighborhoods: ["Canyon Creek", "Prairie Creek", "Cottonwood Heights", "Heights Park", "Breckinridge Park"],
    zipCodes: ["75080", "75081", "75082", "75083"],
    nearbyAttractions: ["UT Dallas", "Richardson Civic Center", "Galatyn Park", "Prairie Creek Park"],
    schoolDistricts: ["Richardson ISD", "Plano ISD"],
    commute: "15-20 minutes to downtown Dallas via US-75",
    keywords: "Richardson homes for sale by owner, FSBO Richardson TX, sell house Richardson, Richardson real estate by owner, for sale by owner Richardson Texas"
  },
  mesquite: {
    name: "Mesquite",
    slug: "mesquite",
    county: "Dallas",
    population: "150,000",
    medianPrice: "$295,000",
    description: "Mesquite is the Rodeo Capital of Texas, offering affordable housing east of Dallas. Strong community spirit, good schools, and easy access to downtown Dallas make it popular for families and first-time buyers.",
    neighborhoods: ["Town East", "Creek Crossing", "Westlake", "Mesquite Heritage", "Range"],
    zipCodes: ["75149", "75150", "75181", "75185"],
    nearbyAttractions: ["Mesquite Championship Rodeo", "Town East Mall", "Mesquite Golf Club"],
    schoolDistricts: ["Mesquite ISD"],
    commute: "20 minutes to downtown Dallas via I-30",
    keywords: "Mesquite homes for sale by owner, FSBO Mesquite TX, sell house Mesquite, Mesquite real estate by owner, for sale by owner Mesquite Texas"
  },
  carrollton: {
    name: "Carrollton",
    slug: "carrollton",
    county: "Dallas/Denton/Collin",
    population: "140,000",
    medianPrice: "$395,000",
    description: "Carrollton spans three counties and offers diverse neighborhoods from historic downtown to modern developments. Excellent location between Dallas and Plano with DART access and strong schools.",
    neighborhoods: ["Old Downtown", "Carrollton Meadows", "Indian Creek", "The Arbors", "Castle Hills"],
    zipCodes: ["75006", "75007", "75010", "75011"],
    nearbyAttractions: ["Historic Downtown Square", "Sandy Lake Park", "A.W. Perry Homestead Museum"],
    schoolDistricts: ["Carrollton-Farmers Branch ISD", "Lewisville ISD"],
    commute: "20 minutes to downtown Dallas via DART Green Line",
    keywords: "Carrollton homes for sale by owner, FSBO Carrollton TX, sell house Carrollton, Carrollton real estate by owner, for sale by owner Carrollton Texas"
  },
  "grand-prairie": {
    name: "Grand Prairie",
    slug: "grand-prairie",
    county: "Dallas/Tarrant/Ellis",
    population: "196,000",
    medianPrice: "$335,000",
    description: "Grand Prairie sits at the crossroads of Dallas, Fort Worth, and Arlington, offering affordable housing with excellent accessibility. Home to Epic Waters Indoor Waterpark, Lone Star Park, and a thriving entertainment district. Growing diverse community with strong job market and value-priced homes.",
    neighborhoods: ["Mira Lagos", "Westchester", "Dalworth Park", "Mountain Creek", "South Grand Prairie", "Carrier District"],
    zipCodes: ["75050", "75051", "75052", "75053", "75054"],
    nearbyAttractions: ["Epic Waters Indoor Waterpark", "Lone Star Park", "Grand Prairie Premium Outlets", "Traders Village", "Verizon Theatre", "Joe Pool Lake"],
    schoolDistricts: ["Grand Prairie ISD", "Arlington ISD", "Mansfield ISD"],
    commute: "20 minutes to Dallas, 15 minutes to Arlington, 25 minutes to Fort Worth",
    keywords: "Grand Prairie homes for sale by owner, FSBO Grand Prairie TX, sell house Grand Prairie, Grand Prairie real estate by owner, for sale by owner Grand Prairie Texas"
  },
  // TARRANT COUNTY
  "fort-worth": {
    name: "Fort Worth",
    slug: "fort-worth",
    county: "Tarrant",
    population: "950,000",
    medianPrice: "$385,000",
    description: "Fort Worth proudly declares 'Where the West Begins' with its Stockyards heritage and cowboy culture. Texas' fifth-largest city combines Western charm with world-class museums in the Cultural District. More affordable than Dallas with a distinct personality and strong job growth.",
    neighborhoods: ["Stockyards", "Cultural District", "West 7th", "Southside", "Tanglewood", "Ridglea", "Arlington Heights", "TCU Area", "Westover Hills", "River Oaks", "Fairmount", "Como", "Overton Park", "Clearfork"],
    zipCodes: ["76102", "76103", "76104", "76107", "76109", "76110", "76116", "76129", "76132", "76133", "76244"],
    nearbyAttractions: ["Stockyards National Historic District", "Kimbell Art Museum", "Fort Worth Zoo", "Sundance Square"],
    schoolDistricts: ["Fort Worth ISD", "Keller ISD", "Eagle Mountain-Saginaw ISD"],
    commute: "30-40 minutes to downtown Dallas via I-30",
    keywords: "Fort Worth homes for sale by owner, FSBO Fort Worth TX, sell house Fort Worth, Fort Worth real estate by owner, for sale by owner Fort Worth Texas, Fort Worth FSBO listings"
  },
  arlington: {
    name: "Arlington",
    slug: "arlington",
    county: "Tarrant",
    population: "400,000",
    medianPrice: "$340,000",
    description: "Arlington sits perfectly between Dallas and Fort Worth, home to AT&T Stadium (Cowboys), Globe Life Field (Rangers), and Six Flags. UTA makes it a college town too. Offers excellent value with big-city entertainment.",
    neighborhoods: ["Downtown Arlington", "Viridian", "North Arlington", "South Arlington", "Pantego"],
    zipCodes: ["76001", "76002", "76006", "76010", "76011", "76012", "76013", "76014", "76015", "76016", "76017"],
    nearbyAttractions: ["AT&T Stadium", "Globe Life Field", "Six Flags Over Texas", "Hurricane Harbor"],
    schoolDistricts: ["Arlington ISD", "Mansfield ISD"],
    commute: "20 minutes to either downtown Dallas or Fort Worth",
    keywords: "Arlington homes for sale by owner, FSBO Arlington TX, sell house Arlington, Arlington real estate by owner, for sale by owner Arlington Texas"
  },
  grapevine: {
    name: "Grapevine",
    slug: "grapevine",
    county: "Tarrant",
    population: "55,000",
    medianPrice: "$525,000",
    description: "Grapevine is the 'Christmas Capital of Texas' with its historic Main Street and Lake Grapevine recreation. Adjacent to DFW Airport yet maintains small-town charm. Excellent schools and wine tourism make it highly desirable.",
    neighborhoods: ["Historic Downtown", "Silver Lake", "Grapevine Mills", "Timberline", "Dove Creek"],
    zipCodes: ["76051", "76092", "76099"],
    nearbyAttractions: ["Grapevine Main Street", "Grapevine Lake", "Grapevine Mills Mall", "Legoland Discovery Center", "SEA LIFE Aquarium"],
    schoolDistricts: ["Grapevine-Colleyville ISD"],
    commute: "Adjacent to DFW Airport, 25 minutes to Dallas or Fort Worth",
    keywords: "Grapevine homes for sale by owner, FSBO Grapevine TX, sell house Grapevine, Grapevine real estate by owner, for sale by owner Grapevine Texas"
  },
  southlake: {
    name: "Southlake",
    slug: "southlake",
    county: "Tarrant",
    population: "32,000",
    medianPrice: "$950,000",
    description: "Southlake is one of the most affluent cities in Texas, known for the famous Carroll Dragons football program and Southlake Town Square. Luxury estates, top-rated schools, and upscale shopping define this prestigious community.",
    neighborhoods: ["Carillon", "Timarron", "Stratford Park", "Shady Oaks", "Coventry Manor"],
    zipCodes: ["76092"],
    nearbyAttractions: ["Southlake Town Square", "Bob Jones Park", "Bicentennial Park"],
    schoolDistricts: ["Carroll ISD"],
    commute: "25 minutes to either downtown Dallas or Fort Worth",
    keywords: "Southlake homes for sale by owner, FSBO Southlake TX, sell house Southlake, Southlake real estate by owner, for sale by owner Southlake Texas, Southlake luxury homes FSBO"
  },
  keller: {
    name: "Keller",
    slug: "keller",
    county: "Tarrant",
    population: "50,000",
    medianPrice: "$550,000",
    description: "Keller is a family-focused suburb with highly-rated Keller ISD schools. Known for its community feel, excellent parks, and quality housing. Named one of the best places to live in Texas repeatedly.",
    neighborhoods: ["Hidden Lakes", "Marshall Ridge", "Bourland Oaks", "Keller Smithfield", "Park Glen"],
    zipCodes: ["76244", "76248"],
    nearbyAttractions: ["Bear Creek Park", "Keller Town Center", "Keller Sports Complex"],
    schoolDistricts: ["Keller ISD"],
    commute: "25 minutes to Fort Worth, 35 minutes to Dallas",
    keywords: "Keller homes for sale by owner, FSBO Keller TX, sell house Keller, Keller real estate by owner, for sale by owner Keller Texas"
  },
  // COLLIN COUNTY
  plano: {
    name: "Plano",
    slug: "plano",
    county: "Collin",
    population: "290,000",
    medianPrice: "$485,000",
    description: "Plano is consistently ranked among America's best places to live with excellent schools, corporate headquarters (Toyota, JCPenney), and vibrant shopping at Legacy West and The Shops at Willow Bend. A mature, affluent suburb with diverse housing options.",
    neighborhoods: ["West Plano", "East Plano", "Legacy West", "Willow Bend", "Park Forest", "Deerfield", "Kings Gate", "Preston Meadows", "Lakeside", "Pecan Hollow"],
    zipCodes: ["75023", "75024", "75025", "75074", "75075", "75093", "75094"],
    nearbyAttractions: ["Legacy West", "The Shops at Willow Bend", "Arbor Hills Nature Preserve", "Oak Point Park"],
    schoolDistricts: ["Plano ISD"],
    commute: "25-30 minutes to downtown Dallas via US-75 or DART",
    keywords: "Plano homes for sale by owner, FSBO Plano TX, sell house Plano, Plano real estate by owner, for sale by owner Plano Texas, West Plano FSBO"
  },
  frisco: {
    name: "Frisco",
    slug: "frisco",
    county: "Collin/Denton",
    population: "220,000",
    medianPrice: "$575,000",
    description: "Frisco is America's fastest-growing city (fastest from 2000-2010) and continues explosive growth. Home to the Dallas Cowboys HQ at The Star, FC Dallas, and numerous corporate relocations. New developments, top schools, and family amenities abound.",
    neighborhoods: ["Starwood", "Stonebriar", "Phillips Creek Ranch", "Richwoods", "Newman Village", "The Trails", "Frisco Lakes", "Plantation Resort", "Edgewood", "Grayhawk"],
    zipCodes: ["75033", "75034", "75035", "75036"],
    nearbyAttractions: ["The Star (Cowboys HQ)", "Toyota Stadium (FC Dallas)", "Stonebriar Centre", "Dr Pepper Ballpark"],
    schoolDistricts: ["Frisco ISD"],
    commute: "35-40 minutes to downtown Dallas via Dallas North Tollway",
    keywords: "Frisco homes for sale by owner, FSBO Frisco TX, sell house Frisco, Frisco real estate by owner, for sale by owner Frisco Texas, Frisco FSBO listings"
  },
  mckinney: {
    name: "McKinney",
    slug: "mckinney",
    county: "Collin",
    population: "205,000",
    medianPrice: "$475,000",
    description: "McKinney was named #1 Best Place to Live in America by Money Magazine. The historic downtown square, excellent McKinney ISD schools, and master-planned communities make it a top destination for families. A perfect blend of charm and growth.",
    neighborhoods: ["Historic Downtown", "Stonebridge Ranch", "Adriatica", "Craig Ranch", "Tucker Hill", "Eldorado", "Melton Ridge"],
    zipCodes: ["75069", "75070", "75071", "75072"],
    nearbyAttractions: ["Historic Downtown McKinney", "Adriatica Village", "Erwin Park", "McKinney Cotton Mill"],
    schoolDistricts: ["McKinney ISD"],
    commute: "35-40 minutes to downtown Dallas via US-75 or Sam Rayburn Tollway",
    keywords: "McKinney homes for sale by owner, FSBO McKinney TX, sell house McKinney, McKinney real estate by owner, for sale by owner McKinney Texas"
  },
  allen: {
    name: "Allen",
    slug: "allen",
    county: "Collin",
    population: "105,000",
    medianPrice: "$475,000",
    description: "Allen is known for the $60 million Eagle Stadium (high school football) and excellent Allen ISD schools. A family-friendly suburb with strong community events, quality housing, and the massive Allen Premium Outlets.",
    neighborhoods: ["Watters Creek", "Twin Creeks", "The Estates", "Montgomery Farm", "Ridgeview Ranch"],
    zipCodes: ["75002", "75013"],
    nearbyAttractions: ["Allen Premium Outlets", "Watters Creek at Montgomery Farm", "Celebration Park", "The Village at Allen"],
    schoolDistricts: ["Allen ISD"],
    commute: "30 minutes to downtown Dallas via US-75",
    keywords: "Allen homes for sale by owner, FSBO Allen TX, sell house Allen, Allen real estate by owner, for sale by owner Allen Texas"
  },
  prosper: {
    name: "Prosper",
    slug: "prosper",
    county: "Collin/Denton",
    population: "35,000",
    medianPrice: "$650,000",
    description: "Prosper is an affluent, rapidly growing town north of Frisco. Known for luxury homes, excellent Prosper ISD schools, and master-planned communities. A top destination for executives relocating to DFW.",
    neighborhoods: ["Whitley Place", "Windsong Ranch", "Star Trail", "Artesia", "Gentle Creek"],
    zipCodes: ["75078"],
    nearbyAttractions: ["Frontier Park", "DPAC Children's Theater", "Prosper Town Center"],
    schoolDistricts: ["Prosper ISD"],
    commute: "40-45 minutes to downtown Dallas via Dallas North Tollway",
    keywords: "Prosper homes for sale by owner, FSBO Prosper TX, sell house Prosper, Prosper real estate by owner, for sale by owner Prosper Texas, Prosper luxury homes"
  },
  celina: {
    name: "Celina",
    slug: "celina",
    county: "Collin/Denton",
    population: "25,000",
    medianPrice: "$550,000",
    description: "Celina is one of the fastest-growing cities in Texas, known as the birthplace of Cream of Wheat. New master-planned communities, Prosper/Celina ISD schools, and rural charm make it attractive for families seeking newer homes.",
    neighborhoods: ["Light Farms", "Mustang Lakes", "Cambridge Crossing", "Glen Crossing"],
    zipCodes: ["75009"],
    nearbyAttractions: ["Old Celina Park", "Light Farms Amenity Center"],
    schoolDistricts: ["Celina ISD", "Prosper ISD"],
    commute: "45-50 minutes to downtown Dallas",
    keywords: "Celina homes for sale by owner, FSBO Celina TX, sell house Celina, Celina real estate by owner, for sale by owner Celina Texas"
  },
  // DENTON COUNTY
  denton: {
    name: "Denton",
    slug: "denton",
    county: "Denton",
    population: "150,000",
    medianPrice: "$365,000",
    description: "Denton is a vibrant college town home to UNT and TWU. The historic downtown square features live music, unique shops, and restaurants. An eclectic, affordable alternative to Dallas suburbs with strong rental potential.",
    neighborhoods: ["Downtown", "Robson Ranch", "Rayzor Ranch", "Southridge", "University Area"],
    zipCodes: ["76201", "76203", "76205", "76207", "76208", "76209", "76210"],
    nearbyAttractions: ["Denton Square", "UNT Campus", "Ray Roberts Lake", "Little D Farmers Market"],
    schoolDistricts: ["Denton ISD"],
    commute: "40 minutes to downtown Dallas via I-35E",
    keywords: "Denton homes for sale by owner, FSBO Denton TX, sell house Denton, Denton real estate by owner, for sale by owner Denton Texas"
  },
  lewisville: {
    name: "Lewisville",
    slug: "lewisville",
    county: "Denton",
    population: "115,000",
    medianPrice: "$375,000",
    description: "Lewisville sits on Lewisville Lake with excellent water recreation. Castle Hills and other master-planned communities offer family-friendly living. Convenient location near DFW Airport and major employment centers.",
    neighborhoods: ["Castle Hills", "Valley Vista", "Garden Ridge", "Lakeland Estates", "Old Town"],
    zipCodes: ["75029", "75056", "75057", "75067"],
    nearbyAttractions: ["Lewisville Lake", "Vista Ridge Mall", "Music City Mall", "Lake Park"],
    schoolDistricts: ["Lewisville ISD"],
    commute: "30 minutes to downtown Dallas via I-35E",
    keywords: "Lewisville homes for sale by owner, FSBO Lewisville TX, sell house Lewisville, Lewisville real estate by owner, for sale by owner Lewisville Texas"
  },
  "flower-mound": {
    name: "Flower Mound",
    slug: "flower-mound",
    county: "Denton",
    population: "80,000",
    medianPrice: "$550,000",
    description: "Flower Mound is an affluent, master-planned community on Grapevine Lake. Known for excellent LISD schools, abundant trails, and family-friendly atmosphere. Named for the prominent mound of flowers on the prairie.",
    neighborhoods: ["Bridlewood", "Wellington", "Tour 18", "Lakewood", "Forest Vista"],
    zipCodes: ["75022", "75028"],
    nearbyAttractions: ["Grapevine Lake", "The River Walk at Central Park", "Flower Mound Community Activity Center"],
    schoolDistricts: ["Lewisville ISD"],
    commute: "30-35 minutes to downtown Dallas or Fort Worth",
    keywords: "Flower Mound homes for sale by owner, FSBO Flower Mound TX, sell house Flower Mound, Flower Mound real estate by owner, for sale by owner Flower Mound Texas"
  },
  "little-elm": {
    name: "Little Elm",
    slug: "little-elm",
    county: "Denton",
    population: "60,000",
    medianPrice: "$425,000",
    description: "Little Elm is a lakeside community on Lewisville Lake experiencing rapid growth. Beach parks, affordable housing, and new schools make it popular with young families. One of the fastest-growing cities in Texas.",
    neighborhoods: ["Paloma Creek", "Lakewood Village", "Union Park", "Sunset Pointe"],
    zipCodes: ["75068"],
    nearbyAttractions: ["Little Elm Park Beach", "Lewisville Lake", "The Tribute Golf Links"],
    schoolDistricts: ["Little Elm ISD", "Denton ISD"],
    commute: "35-40 minutes to downtown Dallas",
    keywords: "Little Elm homes for sale by owner, FSBO Little Elm TX, sell house Little Elm, Little Elm real estate by owner, for sale by owner Little Elm Texas"
  },
  "the-colony": {
    name: "The Colony",
    slug: "the-colony",
    county: "Denton",
    population: "48,000",
    medianPrice: "$395,000",
    description: "The Colony sits on Lewisville Lake with Grandscape entertainment district and Nebraska Furniture Mart. A growing community with good schools and lake access at affordable prices.",
    neighborhoods: ["Stewart Peninsula", "The Tribute", "Austin Waters", "Memorial Village"],
    zipCodes: ["75056"],
    nearbyAttractions: ["Grandscape", "Nebraska Furniture Mart", "Hawaiian Falls", "The Tribute Golf Club"],
    schoolDistricts: ["Lewisville ISD"],
    commute: "30-35 minutes to downtown Dallas",
    keywords: "The Colony homes for sale by owner, FSBO The Colony TX, sell house The Colony, The Colony real estate by owner, for sale by owner The Colony Texas"
  },
  // ROCKWALL COUNTY
  rockwall: {
    name: "Rockwall",
    slug: "rockwall",
    county: "Rockwall",
    population: "50,000",
    medianPrice: "$475,000",
    description: "Rockwall is the county seat of Texas' smallest county, located on Lake Ray Hubbard. Historic downtown, lakefront living, and excellent schools make it a desirable destination. Named for a unique underground rock wall formation.",
    neighborhoods: ["The Harbor", "Heath", "Dalrock", "Chandlers Landing", "Stone Creek"],
    zipCodes: ["75032", "75087"],
    nearbyAttractions: ["The Harbor Rockwall", "Lake Ray Hubbard", "Historic Downtown Square"],
    schoolDistricts: ["Rockwall ISD"],
    commute: "30 minutes to downtown Dallas via I-30",
    keywords: "Rockwall homes for sale by owner, FSBO Rockwall TX, sell house Rockwall, Rockwall real estate by owner, for sale by owner Rockwall Texas"
  },
  // KAUFMAN COUNTY
  forney: {
    name: "Forney",
    slug: "forney",
    county: "Kaufman",
    population: "30,000",
    medianPrice: "$365,000",
    description: "Forney is the Antique Capital of Texas and one of the fastest-growing cities in DFW. Affordable housing, good schools, and easy I-20 access to Dallas make it popular with first-time buyers and young families.",
    neighborhoods: ["Devonshire", "Heritage", "Windmill Farms", "Mustang Creek"],
    zipCodes: ["75126"],
    nearbyAttractions: ["Historic Downtown Antique District", "Forney Community Park"],
    schoolDistricts: ["Forney ISD"],
    commute: "30 minutes to downtown Dallas via I-20",
    keywords: "Forney homes for sale by owner, FSBO Forney TX, sell house Forney, Forney real estate by owner, for sale by owner Forney Texas"
  },
  // ELLIS COUNTY
  waxahachie: {
    name: "Waxahachie",
    slug: "waxahachie",
    county: "Ellis",
    population: "40,000",
    medianPrice: "$350,000",
    description: "Waxahachie is known as the Gingerbread City for its Victorian architecture. The Ellis County seat offers historic charm, affordable housing, and small-town atmosphere with Dallas access via I-35E.",
    neighborhoods: ["Historic District", "Waxahachie Farms", "Parks of Waxahachie"],
    zipCodes: ["75165", "75167"],
    nearbyAttractions: ["Ellis County Courthouse", "Scarborough Renaissance Festival", "Getzendaner Park"],
    schoolDistricts: ["Waxahachie ISD"],
    commute: "35 minutes to downtown Dallas via I-35E",
    keywords: "Waxahachie homes for sale by owner, FSBO Waxahachie TX, sell house Waxahachie, Waxahachie real estate by owner, for sale by owner Waxahachie Texas"
  },
  midlothian: {
    name: "Midlothian",
    slug: "midlothian",
    county: "Ellis",
    population: "35,000",
    medianPrice: "$395,000",
    description: "Midlothian is a growing suburb south of Dallas known for cement production and expanding master-planned communities. Good schools, affordable land, and small-town feel attract families from Dallas.",
    neighborhoods: ["Midlothian Town Center", "Sunrise", "Crystal Forest", "Silken Crossing"],
    zipCodes: ["76065"],
    nearbyAttractions: ["Midlothian Conference Center", "Mockingbird Nature Park"],
    schoolDistricts: ["Midlothian ISD"],
    commute: "35 minutes to downtown Dallas via US-67",
    keywords: "Midlothian homes for sale by owner, FSBO Midlothian TX, sell house Midlothian, Midlothian real estate by owner, for sale by owner Midlothian Texas"
  },
  // JOHNSON COUNTY  
  burleson: {
    name: "Burleson",
    slug: "burleson",
    county: "Johnson/Tarrant",
    population: "50,000",
    medianPrice: "$350,000",
    description: "Burleson is a growing suburb south of Fort Worth with small-town Texas charm. Excellent schools, affordable housing, and easy access to Fort Worth make it popular with families and commuters.",
    neighborhoods: ["Hidden Creek", "Burleson Trails", "Summercrest", "Arena Crossing"],
    zipCodes: ["76028", "76058"],
    nearbyAttractions: ["Old Town Burleson", "Chisenhall Fields Sports Complex"],
    schoolDistricts: ["Burleson ISD"],
    commute: "20 minutes to downtown Fort Worth via I-35W",
    keywords: "Burleson homes for sale by owner, FSBO Burleson TX, sell house Burleson, Burleson real estate by owner, for sale by owner Burleson Texas"
  },
  mansfield: {
    name: "Mansfield",
    slug: "mansfield",
    county: "Tarrant/Johnson/Ellis",
    population: "75,000",
    medianPrice: "$425,000",
    description: "Mansfield is one of the fastest-growing cities in Texas, located between Fort Worth, Arlington, and Dallas. Excellent Mansfield ISD schools and master-planned communities attract families seeking quality housing.",
    neighborhoods: ["Walnut Creek", "The Parks at Mansfield", "Overton Park", "North Pointe"],
    zipCodes: ["76063"],
    nearbyAttractions: ["Big League Dreams Sports Park", "Katherine Rose Memorial Park", "Elmer W. Oliver Nature Park"],
    schoolDistricts: ["Mansfield ISD"],
    commute: "25 minutes to Fort Worth, 30 minutes to Dallas",
    keywords: "Mansfield homes for sale by owner, FSBO Mansfield TX, sell house Mansfield, Mansfield real estate by owner, for sale by owner Mansfield Texas"
  },

  // ADDITIONAL DALLAS COUNTY CITIES
  "farmers-branch": {
    name: "Farmers Branch",
    slug: "farmers-branch",
    county: "Dallas",
    population: "35,000",
    medianPrice: "$365,000",
    description: "Farmers Branch is a well-established suburb north of Dallas known for its excellent parks, diverse dining, and central location. Home to many corporate offices and a strong Asian community with authentic restaurants.",
    neighborhoods: ["Valley View", "Brookhaven", "Mercer Crossing", "Town Center"],
    zipCodes: ["75234", "75244"],
    nearbyAttractions: ["Brookhaven Country Club", "Historical Park", "Farmers Branch Aquatic Center"],
    schoolDistricts: ["Carrollton-Farmers Branch ISD"],
    commute: "15 minutes to downtown Dallas via I-35E",
    keywords: "Farmers Branch homes for sale by owner, FSBO Farmers Branch TX, sell house Farmers Branch"
  },
  rowlett: {
    name: "Rowlett",
    slug: "rowlett",
    county: "Dallas/Rockwall",
    population: "68,000",
    medianPrice: "$385,000",
    description: "Rowlett offers lakefront living on Lake Ray Hubbard with easy Dallas access. The city features beautiful parks, a revitalized downtown, and family-friendly neighborhoods with excellent schools.",
    neighborhoods: ["Bayside", "Miller Heights", "Dalrock", "Princeton Place"],
    zipCodes: ["75088", "75089"],
    nearbyAttractions: ["Lake Ray Hubbard", "Wet Zone Waterpark", "Pecan Grove Park"],
    schoolDistricts: ["Garland ISD", "Rockwall ISD"],
    commute: "25 minutes to downtown Dallas via I-30",
    keywords: "Rowlett homes for sale by owner, FSBO Rowlett TX, sell house Rowlett, Rowlett lakefront homes"
  },
  duncanville: {
    name: "Duncanville",
    slug: "duncanville",
    county: "Dallas",
    population: "40,000",
    medianPrice: "$275,000",
    description: "Duncanville is an affordable, established suburb south of Dallas with strong community pride. Known for its legendary high school basketball program and accessible location near I-20 and I-67.",
    neighborhoods: ["Kiest Forest", "Bear Creek", "Reed Ranch", "Main Street"],
    zipCodes: ["75116", "75137"],
    nearbyAttractions: ["Armstrong Park", "Duncanville Recreation Center", "International Museum of Cultures"],
    schoolDistricts: ["Duncanville ISD"],
    commute: "20 minutes to downtown Dallas via I-20",
    keywords: "Duncanville homes for sale by owner, FSBO Duncanville TX, sell house Duncanville"
  },
  desoto: {
    name: "DeSoto",
    slug: "desoto",
    county: "Dallas",
    population: "55,000",
    medianPrice: "$285,000",
    description: "DeSoto is a diverse, family-oriented suburb south of Dallas with excellent parks and community facilities. Known for its strong schools, affordable housing, and growing commercial development.",
    neighborhoods: ["Thorntree", "Canterbury", "Eagle Heights", "Brookhaven"],
    zipCodes: ["75115"],
    nearbyAttractions: ["DeSoto Civic Center", "Zeiger Park", "Grimes Park"],
    schoolDistricts: ["DeSoto ISD"],
    commute: "20 minutes to downtown Dallas via I-35E",
    keywords: "DeSoto homes for sale by owner, FSBO DeSoto TX, sell house DeSoto"
  },
  lancaster: {
    name: "Lancaster",
    slug: "lancaster",
    county: "Dallas",
    population: "42,000",
    medianPrice: "$245,000",
    description: "Lancaster offers some of the most affordable housing in the DFW metroplex while maintaining easy access to Dallas. A historic Texas town with small-town charm and growing amenities.",
    neighborhoods: ["Country View", "Rolling Meadows", "Houston School Road", "Historic Downtown"],
    zipCodes: ["75134", "75146"],
    nearbyAttractions: ["Lancaster Municipal Airport", "Community Park", "Historic Town Square"],
    schoolDistricts: ["Lancaster ISD"],
    commute: "25 minutes to downtown Dallas via I-35E",
    keywords: "Lancaster homes for sale by owner, FSBO Lancaster TX, sell house Lancaster"
  },
  "cedar-hill": {
    name: "Cedar Hill",
    slug: "cedar-hill",
    county: "Dallas",
    population: "50,000",
    medianPrice: "$325,000",
    description: "Cedar Hill offers natural beauty with Joe Pool Lake and Cedar Hill State Park. Rolling hills, scenic views, and a strong sense of community make it unique among Dallas suburbs.",
    neighborhoods: ["High Pointe", "Lake Ridge", "Waterford Oaks", "Cedar Crest"],
    zipCodes: ["75104"],
    nearbyAttractions: ["Cedar Hill State Park", "Joe Pool Lake", "Dogwood Canyon Audubon Center"],
    schoolDistricts: ["Cedar Hill ISD"],
    commute: "25 minutes to downtown Dallas via US-67",
    keywords: "Cedar Hill homes for sale by owner, FSBO Cedar Hill TX, sell house Cedar Hill"
  },
  "highland-park": {
    name: "Highland Park",
    slug: "highland-park",
    county: "Dallas",
    population: "9,000",
    medianPrice: "$2,100,000",
    description: "Highland Park is one of Texas' most prestigious addresses, an independent city completely surrounded by Dallas. Known for legendary Highland Park ISD schools, historic estates, and old Texas money.",
    neighborhoods: ["Old Highland Park", "Armstrong", "Dallas Country Club", "Lakeside"],
    zipCodes: ["75205"],
    nearbyAttractions: ["Highland Park Village", "Dallas Country Club", "Turtle Creek"],
    schoolDistricts: ["Highland Park ISD"],
    commute: "10 minutes to downtown Dallas",
    keywords: "Highland Park homes for sale by owner, FSBO Highland Park TX, Highland Park luxury homes"
  },
  "university-park": {
    name: "University Park",
    slug: "university-park",
    county: "Dallas",
    population: "25,000",
    medianPrice: "$1,450,000",
    description: "University Park is home to SMU and features tree-lined streets with stately homes. An affluent enclave within Dallas known for Highland Park ISD schools and walkable neighborhoods.",
    neighborhoods: ["Caruth Hills", "Volk Estates", "Normandy", "SMU Area"],
    zipCodes: ["75205", "75225"],
    nearbyAttractions: ["SMU Campus", "Snider Plaza", "George W. Bush Presidential Library"],
    schoolDistricts: ["Highland Park ISD"],
    commute: "10 minutes to downtown Dallas",
    keywords: "University Park homes for sale by owner, FSBO University Park TX, sell house University Park"
  },
  addison: {
    name: "Addison",
    slug: "addison",
    county: "Dallas",
    population: "16,000",
    medianPrice: "$425,000",
    description: "Addison is famous for having more restaurants per capita than any city in America. This small town hosts world-class events including Taste of Addison, Oktoberfest, and Kaboom Town fireworks.",
    neighborhoods: ["Vitruvian Park", "Les Lacs", "Midway Meadows", "Addison Circle"],
    zipCodes: ["75001"],
    nearbyAttractions: ["Addison Circle Park", "Cavanaugh Flight Museum", "Vitruvian Park"],
    schoolDistricts: ["Dallas ISD"],
    commute: "15 minutes to downtown Dallas via Dallas North Tollway",
    keywords: "Addison homes for sale by owner, FSBO Addison TX, sell house Addison"
  },
  coppell: {
    name: "Coppell",
    slug: "coppell",
    county: "Dallas",
    population: "42,000",
    medianPrice: "$550,000",
    description: "Coppell is a family-focused suburb known for exceptional Coppell ISD schools. Located near DFW Airport with beautiful parks, trails, and a strong sense of community.",
    neighborhoods: ["Old Coppell", "Riverchase", "Northlake Woodlands", "Stratford Park"],
    zipCodes: ["75019"],
    nearbyAttractions: ["Old Town Coppell", "Andrew Brown Park", "Wagon Wheel Park"],
    schoolDistricts: ["Coppell ISD"],
    commute: "25 minutes to downtown Dallas, adjacent to DFW Airport",
    keywords: "Coppell homes for sale by owner, FSBO Coppell TX, sell house Coppell"
  },

  // ADDITIONAL TARRANT COUNTY CITIES
  euless: {
    name: "Euless",
    slug: "euless",
    county: "Tarrant",
    population: "56,000",
    medianPrice: "$325,000",
    description: "Euless sits in the HEB (Hurst-Euless-Bedford) area, offering affordable housing near DFW Airport. A diverse community with excellent parks and easy access to both Dallas and Fort Worth.",
    neighborhoods: ["Bear Creek", "Parks of Euless", "Midway Park", "Industrial"],
    zipCodes: ["76039", "76040"],
    nearbyAttractions: ["Texas Star Golf Course", "Bob Eden Park", "Heritage Park"],
    schoolDistricts: ["Hurst-Euless-Bedford ISD"],
    commute: "Adjacent to DFW Airport, 25 minutes to Dallas or Fort Worth",
    keywords: "Euless homes for sale by owner, FSBO Euless TX, sell house Euless"
  },
  bedford: {
    name: "Bedford",
    slug: "bedford",
    county: "Tarrant",
    population: "50,000",
    medianPrice: "$345,000",
    description: "Bedford is a well-established suburb in the HEB area with excellent schools and family amenities. Home to Bedford Boys Ranch and numerous community events throughout the year.",
    neighborhoods: ["Bedford Heights", "Shady Brook", "Stonegate", "Meadow Park"],
    zipCodes: ["76021", "76022"],
    nearbyAttractions: ["Bedford Boys Ranch", "First Baptist Church Bedford", "Central Park"],
    schoolDistricts: ["Hurst-Euless-Bedford ISD"],
    commute: "25 minutes to Dallas or Fort Worth",
    keywords: "Bedford homes for sale by owner, FSBO Bedford TX, sell house Bedford"
  },
  hurst: {
    name: "Hurst",
    slug: "hurst",
    county: "Tarrant",
    population: "40,000",
    medianPrice: "$315,000",
    description: "Hurst anchors the HEB tri-city area with North East Mall and excellent community facilities. An affordable, family-friendly suburb with strong schools and central location.",
    neighborhoods: ["Bellaire", "Brookside", "Redbud", "Pipeline"],
    zipCodes: ["76053", "76054"],
    nearbyAttractions: ["North East Mall", "Chisholm Park", "Hurst Recreation Center"],
    schoolDistricts: ["Hurst-Euless-Bedford ISD"],
    commute: "20 minutes to Fort Worth, 30 minutes to Dallas",
    keywords: "Hurst homes for sale by owner, FSBO Hurst TX, sell house Hurst"
  },
  colleyville: {
    name: "Colleyville",
    slug: "colleyville",
    county: "Tarrant",
    population: "27,000",
    medianPrice: "$750,000",
    description: "Colleyville is an affluent suburb between Dallas and Fort Worth known for Grapevine-Colleyville ISD schools. Estate homes, wooded lots, and a small-town feel attract executives and families.",
    neighborhoods: ["Montclair Parc", "Bransford Estates", "The Oaks", "Colleyville Downs"],
    zipCodes: ["76034"],
    nearbyAttractions: ["Colleyville Nature Center", "Market Street", "Colleyville Center"],
    schoolDistricts: ["Grapevine-Colleyville ISD"],
    commute: "25 minutes to Dallas or Fort Worth",
    keywords: "Colleyville homes for sale by owner, FSBO Colleyville TX, Colleyville luxury homes"
  },
  "north-richland-hills": {
    name: "North Richland Hills",
    slug: "north-richland-hills",
    county: "Tarrant",
    population: "72,000",
    medianPrice: "$325,000",
    description: "North Richland Hills (NRH) offers affordable housing with excellent recreation facilities. NRH2O Family Water Park and Iron Horse Golf Course make it a family destination.",
    neighborhoods: ["Smithfield", "Meadow Lakes", "Fossil Creek", "Holiday Heights"],
    zipCodes: ["76180", "76182"],
    nearbyAttractions: ["NRH2O Family Water Park", "Iron Horse Golf Course", "Adventure World"],
    schoolDistricts: ["Birdville ISD"],
    commute: "20 minutes to Fort Worth, 30 minutes to Dallas",
    keywords: "North Richland Hills homes for sale by owner, FSBO NRH TX, sell house North Richland Hills"
  },
  "haltom-city": {
    name: "Haltom City",
    slug: "haltom-city",
    county: "Tarrant",
    population: "45,000",
    medianPrice: "$245,000",
    description: "Haltom City offers some of the most affordable housing in the mid-cities area. A diverse, working-class community with easy access to Fort Worth and a growing local business scene.",
    neighborhoods: ["Haltom Heights", "Birdville", "Diamond Oaks", "Eastside"],
    zipCodes: ["76117", "76137"],
    nearbyAttractions: ["Buffalo Ridge Park", "Haltom City Library", "Local restaurants"],
    schoolDistricts: ["Birdville ISD", "Haltom City"],
    commute: "15 minutes to Fort Worth, 35 minutes to Dallas",
    keywords: "Haltom City homes for sale by owner, FSBO Haltom City TX, sell house Haltom City"
  },
  benbrook: {
    name: "Benbrook",
    slug: "benbrook",
    county: "Tarrant",
    population: "24,000",
    medianPrice: "$295,000",
    description: "Benbrook offers lakeside living on Benbrook Lake southwest of Fort Worth. Popular with families seeking outdoor recreation, fishing, and a quieter pace than urban Fort Worth.",
    neighborhoods: ["Lakeside", "Westpark", "Whitestone", "Rolling Hills"],
    zipCodes: ["76109", "76116", "76126"],
    nearbyAttractions: ["Benbrook Lake", "Dutch Branch Park", "Benbrook Community Center"],
    schoolDistricts: ["Fort Worth ISD"],
    commute: "15 minutes to downtown Fort Worth",
    keywords: "Benbrook homes for sale by owner, FSBO Benbrook TX, Benbrook lakefront homes"
  },
  saginaw: {
    name: "Saginaw",
    slug: "saginaw",
    county: "Tarrant",
    population: "25,000",
    medianPrice: "$295,000",
    description: "Saginaw is a growing suburb north of Fort Worth with affordable new construction. Eagle Mountain-Saginaw ISD schools and easy access to Fort Worth attract young families.",
    neighborhoods: ["Saginaw Park", "Willow Creek", "Eagle Ranch", "Western Oaks"],
    zipCodes: ["76131", "76179"],
    nearbyAttractions: ["Saginaw Recreation Center", "Willow Creek Park"],
    schoolDistricts: ["Eagle Mountain-Saginaw ISD"],
    commute: "20 minutes to downtown Fort Worth",
    keywords: "Saginaw homes for sale by owner, FSBO Saginaw TX, sell house Saginaw"
  },
  roanoke: {
    name: "Roanoke",
    slug: "roanoke",
    county: "Denton",
    population: "10,000",
    medianPrice: "$475,000",
    description: "Roanoke is the 'Unique Dining Capital of Texas' with its historic Oak Street lined with restaurants. A charming small town that has maintained character while experiencing growth.",
    neighborhoods: ["Oak Street Historic", "Roanoke Estates", "Highlands of Roanoke", "Dove Hollow"],
    zipCodes: ["76262"],
    nearbyAttractions: ["Historic Oak Street", "Roanoke Visitor Center", "Hawaiian Falls"],
    schoolDistricts: ["Northwest ISD"],
    commute: "30 minutes to Fort Worth or Dallas",
    keywords: "Roanoke homes for sale by owner, FSBO Roanoke TX, sell house Roanoke"
  },
  "trophy-club": {
    name: "Trophy Club",
    slug: "trophy-club",
    county: "Denton/Tarrant",
    population: "13,000",
    medianPrice: "$525,000",
    description: "Trophy Club is an affluent master-planned community built around the Trophy Club Country Club. Known for excellent Northwest ISD schools and resort-style amenities.",
    neighborhoods: ["The Highlands", "Indian Creek", "Hogan's Glen", "Trophy Wood"],
    zipCodes: ["76262"],
    nearbyAttractions: ["Trophy Club Country Club", "Marshall Creek Ranch", "Trophy Club Park"],
    schoolDistricts: ["Northwest ISD"],
    commute: "30 minutes to Fort Worth, 35 minutes to Dallas",
    keywords: "Trophy Club homes for sale by owner, FSBO Trophy Club TX, Trophy Club golf homes"
  },
  crowley: {
    name: "Crowley",
    slug: "crowley",
    county: "Tarrant",
    population: "18,000",
    medianPrice: "$285,000",
    description: "Crowley is a small, tight-knit community south of Fort Worth offering affordable housing. Known for its annual Western Days celebration and small-town Texas atmosphere.",
    neighborhoods: ["Meadow Creek", "Hulen Heights", "Eagle Ridge", "Westside"],
    zipCodes: ["76036"],
    nearbyAttractions: ["Crowley Recreation Center", "Bicentennial Park"],
    schoolDistricts: ["Crowley ISD"],
    commute: "20 minutes to downtown Fort Worth",
    keywords: "Crowley homes for sale by owner, FSBO Crowley TX, sell house Crowley"
  },

  // ADDITIONAL COLLIN COUNTY CITIES
  anna: {
    name: "Anna",
    slug: "anna",
    county: "Collin",
    population: "18,000",
    medianPrice: "$385,000",
    description: "Anna is one of the fastest-growing cities in Collin County, offering affordable new construction. Anna ISD schools and small-town charm attract families from McKinney and Plano.",
    neighborhoods: ["Hurricane Creek", "Anna Ranch", "Saddlebrook", "Creeks of Legacy"],
    zipCodes: ["75409"],
    nearbyAttractions: ["Anna City Park", "Slayter Creek Park", "Historic Downtown Anna"],
    schoolDistricts: ["Anna ISD"],
    commute: "45 minutes to downtown Dallas via US-75",
    keywords: "Anna homes for sale by owner, FSBO Anna TX, sell house Anna"
  },
  princeton: {
    name: "Princeton",
    slug: "princeton",
    county: "Collin",
    population: "18,000",
    medianPrice: "$365,000",
    description: "Princeton is experiencing explosive growth as DFW expands northeast. Affordable land and new construction attract families seeking value in Collin County.",
    neighborhoods: ["Princeton Meadows", "Woodcreek", "Crawford Farms", "Chapel Hill"],
    zipCodes: ["75407"],
    nearbyAttractions: ["Princeton City Park", "Lake Lavon nearby", "Historic Downtown"],
    schoolDistricts: ["Princeton ISD"],
    commute: "40 minutes to downtown Dallas via US-380",
    keywords: "Princeton homes for sale by owner, FSBO Princeton TX, sell house Princeton"
  },
  melissa: {
    name: "Melissa",
    slug: "melissa",
    county: "Collin",
    population: "15,000",
    medianPrice: "$425,000",
    description: "Melissa is a rapidly growing small town between McKinney and Anna. Melissa ISD schools and new master-planned communities attract families seeking quality at lower prices than McKinney.",
    neighborhoods: ["Palomino Estates", "Mustang Creek", "Stonebridge Meadows", "Melissa Highlands"],
    zipCodes: ["75454"],
    nearbyAttractions: ["Melissa City Park", "Cardinal Creek Golf Club", "Historic Melissa"],
    schoolDistricts: ["Melissa ISD"],
    commute: "40 minutes to downtown Dallas",
    keywords: "Melissa homes for sale by owner, FSBO Melissa TX, sell house Melissa"
  },
  murphy: {
    name: "Murphy",
    slug: "murphy",
    county: "Collin",
    population: "22,000",
    medianPrice: "$485,000",
    description: "Murphy is a small, family-focused city between Plano and Wylie. Known for excellent Plano ISD schools and a strong sense of community with well-maintained neighborhoods.",
    neighborhoods: ["Maxwell Creek", "Southfork", "Country Brook", "Murphy Park Estates"],
    zipCodes: ["75094"],
    nearbyAttractions: ["Murphy Central Park", "Five Mile Creek Greenbelt", "Murphy Recreation Center"],
    schoolDistricts: ["Plano ISD", "Wylie ISD"],
    commute: "25 minutes to downtown Dallas",
    keywords: "Murphy homes for sale by owner, FSBO Murphy TX, sell house Murphy"
  },
  wylie: {
    name: "Wylie",
    slug: "wylie",
    county: "Collin/Dallas/Rockwall",
    population: "55,000",
    medianPrice: "$395,000",
    description: "Wylie is a fast-growing suburb on Lake Lavon offering lakefront living and excellent Wylie ISD schools. A family-oriented community with small-town character and modern amenities.",
    neighborhoods: ["Inspiration", "Stone Creek", "Birmingham Farms", "Watermill"],
    zipCodes: ["75098"],
    nearbyAttractions: ["Lake Lavon", "Founder's Park", "Wylie Splash Park", "Historic Downtown"],
    schoolDistricts: ["Wylie ISD"],
    commute: "30 minutes to downtown Dallas",
    keywords: "Wylie homes for sale by owner, FSBO Wylie TX, Wylie lakefront homes"
  },
  fairview: {
    name: "Fairview",
    slug: "fairview",
    county: "Collin",
    population: "10,000",
    medianPrice: "$650,000",
    description: "Fairview is an affluent town between Allen and McKinney known for large lots and estate homes. Quiet, rural character with top-rated Lovejoy ISD schools.",
    neighborhoods: ["Heritage Ranch", "Fairview Farms", "The Estates", "Country Living"],
    zipCodes: ["75069"],
    nearbyAttractions: ["Heritage Ranch Golf Club", "Heard-Craig Center for the Arts"],
    schoolDistricts: ["Lovejoy ISD"],
    commute: "35 minutes to downtown Dallas",
    keywords: "Fairview homes for sale by owner, FSBO Fairview TX, Fairview estate homes"
  },

  // ADDITIONAL DENTON COUNTY CITIES
  corinth: {
    name: "Corinth",
    slug: "corinth",
    county: "Denton",
    population: "23,000",
    medianPrice: "$385,000",
    description: "Corinth is a family-friendly suburb between Denton and Lewisville. Known for excellent Lake Dallas ISD schools, community events, and accessible I-35E location.",
    neighborhoods: ["Oakmont", "Lake Sharon", "Corinth Estates", "The Preserve"],
    zipCodes: ["76210"],
    nearbyAttractions: ["Lake Dallas nearby", "Community Park", "Corinth Square"],
    schoolDistricts: ["Lake Dallas ISD", "Denton ISD"],
    commute: "30 minutes to downtown Dallas via I-35E",
    keywords: "Corinth homes for sale by owner, FSBO Corinth TX, sell house Corinth"
  },
  "highland-village": {
    name: "Highland Village",
    slug: "highland-village",
    county: "Denton",
    population: "16,000",
    medianPrice: "$525,000",
    description: "Highland Village is an affluent lakeside community on Lewisville Lake. Excellent Lewisville ISD schools, beautiful parks, and resort-like amenities attract families.",
    neighborhoods: ["The Shores", "Highland Meadows", "Lakewood", "Castlewood"],
    zipCodes: ["75077"],
    nearbyAttractions: ["Lewisville Lake", "The Shops at Highland Village", "Doubletree Ranch Park"],
    schoolDistricts: ["Lewisville ISD"],
    commute: "30 minutes to downtown Dallas",
    keywords: "Highland Village homes for sale by owner, FSBO Highland Village TX, Highland Village lakefront"
  },
  argyle: {
    name: "Argyle",
    slug: "argyle",
    county: "Denton",
    population: "5,000",
    medianPrice: "$650,000",
    description: "Argyle is a rural community known for horse properties and estate homes. Growing rapidly while maintaining open spaces and small-town Texas character.",
    neighborhoods: ["Argyle Forest", "The Oaks", "Harvest", "Bartonville Farms"],
    zipCodes: ["76226"],
    nearbyAttractions: ["Argyle Feed Store", "Canyon Falls", "Harvest development"],
    schoolDistricts: ["Argyle ISD"],
    commute: "35 minutes to Dallas or Fort Worth",
    keywords: "Argyle homes for sale by owner, FSBO Argyle TX, Argyle horse property"
  },
  aubrey: {
    name: "Aubrey",
    slug: "aubrey",
    county: "Denton",
    population: "7,000",
    medianPrice: "$425,000",
    description: "Aubrey is a small town experiencing rapid growth north of Denton. Affordable land and new construction attract families seeking value with room to grow.",
    neighborhoods: ["Silverado", "Jackson Ridge", "Providence", "Stoney Creek"],
    zipCodes: ["76227"],
    nearbyAttractions: ["Aubrey City Park", "Tanglewood Golf Course", "Historic Downtown"],
    schoolDistricts: ["Aubrey ISD", "Denton ISD"],
    commute: "45 minutes to Dallas, 35 minutes to Fort Worth",
    keywords: "Aubrey homes for sale by owner, FSBO Aubrey TX, sell house Aubrey"
  },
  sanger: {
    name: "Sanger",
    slug: "sanger",
    county: "Denton",
    population: "10,000",
    medianPrice: "$335,000",
    description: "Sanger is a small town north of Denton with affordable housing and access to Ray Roberts Lake. Growing families appreciate the small-town atmosphere and lower home prices.",
    neighborhoods: ["Indian Hills", "Sanger Heights", "Clear Creek", "Lake Ray Roberts area"],
    zipCodes: ["76266"],
    nearbyAttractions: ["Ray Roberts Lake State Park", "Sanger Selz Museum", "Historic Downtown"],
    schoolDistricts: ["Sanger ISD"],
    commute: "45 minutes to Dallas via I-35",
    keywords: "Sanger homes for sale by owner, FSBO Sanger TX, sell house Sanger"
  },

  // ROCKWALL/KAUFMAN COUNTY CITIES
  heath: {
    name: "Heath",
    slug: "heath",
    county: "Rockwall",
    population: "10,000",
    medianPrice: "$650,000",
    description: "Heath is an upscale community on Lake Ray Hubbard known for large estates and waterfront properties. Rockwall ISD schools and quiet, family-oriented atmosphere.",
    neighborhoods: ["Heath Golf & Yacht Club", "Buffalo Creek", "Laurence Drive Estates", "Lake Pointe"],
    zipCodes: ["75032"],
    nearbyAttractions: ["Buffalo Creek Golf Club", "Lake Ray Hubbard", "Heath City Park"],
    schoolDistricts: ["Rockwall ISD"],
    commute: "30 minutes to downtown Dallas",
    keywords: "Heath homes for sale by owner, FSBO Heath TX, Heath waterfront homes"
  },
  fate: {
    name: "Fate",
    slug: "fate",
    county: "Rockwall",
    population: "20,000",
    medianPrice: "$385,000",
    description: "Fate is one of the fastest-growing cities in Texas with affordable new construction. Master-planned communities and Rockwall ISD schools attract young families.",
    neighborhoods: ["Woodcreek", "Chamberlain Crossing", "Williamsburg", "Summer Bend"],
    zipCodes: ["75087", "75189"],
    nearbyAttractions: ["Fate City Park", "Lake Ray Hubbard nearby"],
    schoolDistricts: ["Rockwall ISD", "Royse City ISD"],
    commute: "35 minutes to downtown Dallas",
    keywords: "Fate homes for sale by owner, FSBO Fate TX, sell house Fate"
  },
  "royse-city": {
    name: "Royse City",
    slug: "royse-city",
    county: "Rockwall/Hunt",
    population: "18,000",
    medianPrice: "$355,000",
    description: "Royse City offers affordable housing east of Dallas with small-town character. Growing commercial development and new construction attract budget-conscious families.",
    neighborhoods: ["Creekview", "Southgate", "Meadow Vista", "Pullen"],
    zipCodes: ["75189"],
    nearbyAttractions: ["Royse City Main Street", "Lake Ray Hubbard nearby", "City Park"],
    schoolDistricts: ["Royse City ISD"],
    commute: "35 minutes to downtown Dallas",
    keywords: "Royse City homes for sale by owner, FSBO Royse City TX, sell house Royse City"
  },
  terrell: {
    name: "Terrell",
    slug: "terrell",
    county: "Kaufman",
    population: "18,000",
    medianPrice: "$275,000",
    description: "Terrell is a historic Texas town east of Dallas offering affordable housing and small-town living. Known for Terrell Heritage Jubilee and growing logistics industry.",
    neighborhoods: ["Heritage Park", "Ben Gill Park area", "North Terrell", "Brin"],
    zipCodes: ["75160"],
    nearbyAttractions: ["Terrell Heritage Museum", "Ben Gill Park", "Silent Wings Museum"],
    schoolDistricts: ["Terrell ISD"],
    commute: "35 minutes to downtown Dallas via I-20",
    keywords: "Terrell homes for sale by owner, FSBO Terrell TX, sell house Terrell"
  },

  // ELLIS COUNTY ADDITIONAL
  "red-oak": {
    name: "Red Oak",
    slug: "red-oak",
    county: "Ellis",
    population: "15,000",
    medianPrice: "$325,000",
    description: "Red Oak is a growing suburb south of Dallas with affordable new construction. Red Oak ISD schools and easy I-35E access attract families from Dallas.",
    neighborhoods: ["Brentwood Estates", "Reserve at Red Oak", "Stagecoach Crossing", "Lost Oak"],
    zipCodes: ["75154"],
    nearbyAttractions: ["Red Oak City Park", "Ovilla Road shopping", "Joe Pool Lake nearby"],
    schoolDistricts: ["Red Oak ISD"],
    commute: "30 minutes to downtown Dallas",
    keywords: "Red Oak homes for sale by owner, FSBO Red Oak TX, sell house Red Oak"
  },
  ennis: {
    name: "Ennis",
    slug: "ennis",
    county: "Ellis",
    population: "20,000",
    medianPrice: "$265,000",
    description: "Ennis is the official 'Bluebonnet City of Texas' known for spectacular spring wildflowers. A historic railroad town with affordable housing and small-town charm.",
    neighborhoods: ["Lake Bardwell area", "Creekside", "Northgate", "Historic Downtown"],
    zipCodes: ["75119"],
    nearbyAttractions: ["Bluebonnet Trails", "Texas Motorplex", "Lake Bardwell"],
    schoolDistricts: ["Ennis ISD"],
    commute: "40 minutes to downtown Dallas",
    keywords: "Ennis homes for sale by owner, FSBO Ennis TX, sell house Ennis"
  },
  "glenn-heights": {
    name: "Glenn Heights",
    slug: "glenn-heights",
    county: "Dallas/Ellis",
    population: "14,000",
    medianPrice: "$295,000",
    description: "Glenn Heights is a small, diverse suburb between Dallas and Waxahachie. Affordable housing and multiple school district options attract first-time buyers.",
    neighborhoods: ["Hampton Hills", "Bear Creek", "Northwood", "Country Meadows"],
    zipCodes: ["75154"],
    nearbyAttractions: ["Countryside Park", "Hampton Hills Shopping"],
    schoolDistricts: ["Glenn Heights ISD", "Red Oak ISD"],
    commute: "25 minutes to downtown Dallas",
    keywords: "Glenn Heights homes for sale by owner, FSBO Glenn Heights TX, sell house Glenn Heights"
  },

  // JOHNSON COUNTY ADDITIONAL  
  cleburne: {
    name: "Cleburne",
    slug: "cleburne",
    county: "Johnson",
    population: "32,000",
    medianPrice: "$285,000",
    description: "Cleburne is the Johnson County seat with historic downtown charm and Lake Pat Cleburne recreation. Affordable housing, rodeo culture, and Texas heritage attract families.",
    neighborhoods: ["Lake Pat Cleburne", "Westhill", "Southside", "Country Club"],
    zipCodes: ["76031", "76033"],
    nearbyAttractions: ["Lake Pat Cleburne", "Cleburne State Park", "Layland Museum"],
    schoolDistricts: ["Cleburne ISD"],
    commute: "35 minutes to Fort Worth",
    keywords: "Cleburne homes for sale by owner, FSBO Cleburne TX, sell house Cleburne"
  },

  // PARKER COUNTY
  weatherford: {
    name: "Weatherford",
    slug: "weatherford",
    county: "Parker",
    population: "35,000",
    medianPrice: "$375,000",
    description: "Weatherford is the 'Peach Capital of Texas' and Parker County seat. Historic downtown, horse culture, and scenic Hill Country terrain attract those seeking rural Texas living.",
    neighborhoods: ["Pecan Plantation", "Crown Pointe", "Bankhead", "Dennis"],
    zipCodes: ["76086", "76087", "76088"],
    nearbyAttractions: ["Historic Downtown Square", "Chandor Gardens", "Clark Gardens"],
    schoolDistricts: ["Weatherford ISD"],
    commute: "30 minutes to Fort Worth",
    keywords: "Weatherford homes for sale by owner, FSBO Weatherford TX, Weatherford horse property"
  },
  aledo: {
    name: "Aledo",
    slug: "aledo",
    county: "Parker",
    population: "6,000",
    medianPrice: "$525,000",
    description: "Aledo is known for its powerhouse high school football program and excellent Aledo ISD schools. A small, affluent community west of Fort Worth with rural character.",
    neighborhoods: ["Walsh Ranch", "Parks of Aledo", "Morningstar", "Crown Ridge"],
    zipCodes: ["76008"],
    nearbyAttractions: ["Aledo Downtown", "Walsh development"],
    schoolDistricts: ["Aledo ISD"],
    commute: "25 minutes to Fort Worth",
    keywords: "Aledo homes for sale by owner, FSBO Aledo TX, sell house Aledo"
  },
  "willow-park": {
    name: "Willow Park",
    slug: "willow-park",
    county: "Parker",
    population: "6,000",
    medianPrice: "$425,000",
    description: "Willow Park is a small city on I-20 west of Fort Worth known for Willow Park Village and family-friendly atmosphere. Growing while maintaining suburban character.",
    neighborhoods: ["Crown Pointe", "Trinity Meadows", "Willow Park North", "Ranch House Road"],
    zipCodes: ["76087"],
    nearbyAttractions: ["Squaw Creek Park", "Willow Park Village"],
    schoolDistricts: ["Weatherford ISD", "Aledo ISD"],
    commute: "25 minutes to Fort Worth",
    keywords: "Willow Park homes for sale by owner, FSBO Willow Park TX, sell house Willow Park"
  },

  // WISE COUNTY
  decatur: {
    name: "Decatur",
    slug: "decatur",
    county: "Wise",
    population: "7,000",
    medianPrice: "$295,000",
    description: "Decatur is the Wise County seat with historic courthouse square and small-town Texas charm. The 'Eighter from Decatur' slogan and rodeo culture define this community.",
    neighborhoods: ["LBJ National Grasslands area", "Downtown Historic", "US-287 Corridor"],
    zipCodes: ["76234"],
    nearbyAttractions: ["Wise County Courthouse", "LBJ National Grasslands", "Decatur Conference Center"],
    schoolDistricts: ["Decatur ISD"],
    commute: "45 minutes to Fort Worth",
    keywords: "Decatur homes for sale by owner, FSBO Decatur TX, sell house Decatur"
  },

  // HOOD COUNTY
  granbury: {
    name: "Granbury",
    slug: "granbury",
    county: "Hood",
    population: "12,000",
    medianPrice: "$365,000",
    description: "Granbury is a charming lakeside town on Lake Granbury with a historic downtown square. Popular for weekend getaways, retirees, and those seeking small-town waterfront living.",
    neighborhoods: ["Pecan Plantation", "DeCordova", "Harbor Lakes", "Sky Harbour"],
    zipCodes: ["76048", "76049"],
    nearbyAttractions: ["Lake Granbury", "Historic Downtown Square", "Granbury Opera House", "Fossil Rim Wildlife Center"],
    schoolDistricts: ["Granbury ISD"],
    commute: "45 minutes to Fort Worth",
    keywords: "Granbury homes for sale by owner, FSBO Granbury TX, Granbury lakefront homes"
  }
};

// Helper function to get all city slugs
export const getAllCitySlugs = () => Object.keys(dfwCities);

// Helper function to get all county slugs
export const getAllCountySlugs = () => Object.keys(dfwCounties);

// Helper function to get cities by county
export const getCitiesByCounty = (countyName) => {
  const county = Object.values(dfwCounties).find(c => c.name === countyName);
  return county ? county.cities : [];
};
